/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentCapabilitiesControllerListQueryResponse } from "../../models/incidentAgentController/IncidentCapabilitiesControllerList";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { incidentCapabilitiesControllerList } from "../../clients/incident-agentService/incidentCapabilitiesControllerList";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const incidentCapabilitiesControllerListQueryKey = () => [{
  url: '/api/v1/incident-agent/capabilities'
}] as const;
export type IncidentCapabilitiesControllerListQueryKey = ReturnType<typeof incidentCapabilitiesControllerListQueryKey>;
export function incidentCapabilitiesControllerListQueryOptions(config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = incidentCapabilitiesControllerListQueryKey();
  return queryOptions<IncidentCapabilitiesControllerListQueryResponse, ResponseErrorConfig<Error>, IncidentCapabilitiesControllerListQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return incidentCapabilitiesControllerList(config);
    }
  });
}

/**
 * {@link /api/v1/incident-agent/capabilities}
 */
export function useIncidentCapabilitiesControllerList<TData = IncidentCapabilitiesControllerListQueryResponse, TQueryData = IncidentCapabilitiesControllerListQueryResponse, TQueryKey extends QueryKey = IncidentCapabilitiesControllerListQueryKey>(options: {
  query?: Partial<QueryObserverOptions<IncidentCapabilitiesControllerListQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? incidentCapabilitiesControllerListQueryKey();
  const query = useQuery({
    ...incidentCapabilitiesControllerListQueryOptions(config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}